export default class MissingStartersException {
  public message: string
  constructor(message: string) {
    this.message = message
  }
}
